import React, { useEffect, useState } from 'react';
import MapboxMap from './MapboxMap.jsx';
import { fetchListings } from './api.js';
import agent from './agent.js';

function MapPage() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const agentId = agent.sparkAgentId;
    if (!agentId) {
      setError('Missing agent ID');
      setLoading(false);
      return;
    }
    fetchListings({ agentId })
      .then(data => {
        setListings(data);
        setLoading(false);
      })
      .catch(e => {
        setError(e.message || 'Failed to fetch listings');
        setLoading(false);
      });
  }, []);

  return (
    <div style={{ 
      width: '100%', 
      height: 'auto', 
      position: 'relative',
      background: '#ddd',
      padding: '20px'
    }}>
      <h1 style={{ 
        marginTop: 0,
        color: 'var(--primary-dark-blue)'
      }}>Map View</h1>
      
      {loading ? (
        <div style={{ padding: 32 }}>Loading map...</div>
      ) : error ? (
        <div style={{ padding: 32, color: 'red' }}>{error}</div>
      ) : (
        <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
          <MapboxMap listings={listings} />
        </div>
      )}
      
      <div style={{ marginTop: 20 }}>
        <a href="/" style={{
          background: 'var(--primary-dark-blue)',
          color: '#fff',
          padding: '12px 24px',
          borderRadius: 8,
          fontWeight: 700,
          textDecoration: 'none',
          fontSize: 16,
          display: 'inline-block',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>Back to Listings</a>
      </div>
    </div>
  );
}

export default MapPage;
